module.exports = __webpack_public_path__ + "static/img/MMblue.f7522fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MMblue.png
// module id = CO6P
// module chunks = 1